
import template from './site-operational-status-indicator.html';


export default class SiteOperationalStatusIndicatorComponent {
  constructor() {
    this.template = template;
    this.bindings = {
      status: '<',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/site-operational-status/components/site-operational-status-indicator/site-operational-status-indicator-component.js